import React, {useEffect, useRef, useState} from "react";
import {arraySorter, DatePicker, Form, InputBox, notification, Table} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import _ from "lodash";
import {fetchProduct, GroupedProductList} from "../products/actions";
import {GetEachFormFields} from "../../components/_utils/formUtils";
import moment from "moment";
import {tableListFxn} from "../pos/actions";
import {userListFxn} from "../userManager/actions";

function GroupedProductsList(props) {
    let tableRef = useRef();
    const {getFieldValue} = props.form;
    let [products, setProducts] = useState([]);
    const [activeTab, setActiveTab] = useState("today");
    const [dates, setDates] = useState({
        fromDate: '',
        toDate: '',
    });

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                /*if (getFieldValue('fromD') && getFieldValue('toD')) {
                    params.fromD = getFieldValue('fromD')
                    params.toD = getFieldValue('toD')
                } else {
                    let currentDate = moment();
                    params.fromD = moment(currentDate).startOf('month').toDate();
                    params.toD = moment(currentDate).endOf('month').toDate();
                }*/
                if (dates.fromDate && dates.toDate) {
                    /*params.date = {
                        $gte: moment(dates.fromDate).startOf('day')._d,
                        $lte: moment(dates.toDate).endOf('day')._d,
                    };*/
                    params.fromD = moment(dates.fromDate).startOf('day')._d
                    params.toD = moment(dates.toDate).endOf('day')._d
                }
                console.log(params,'parmas')
                if (getFieldValue('productIds')) {
                    params.productIds = getFieldValue('productIds')
                }
                // if (getFieldValue('tableName')) {
                //     let table = tableList.find(table => table.name === getFieldValue('tableName'));
                //     const keysArray = table.tables.map(item => item.key);
                //     console.log(keysArray,"tables array")
                //     params.tableNameArray = keysArray
                // }
                // if (getFieldValue('userId')) {
                //     params.userId = getFieldValue('userId')
                // }
                const data = await GroupedProductList({...params});
                console.log(data, 'data')
                resolve(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };

    const getProducts = async (params = {}) => {
        params.results = 10000
        const data = await fetchProduct({...params});
        setProducts(arraySorter(data.data.data))
    }
    //
    // let [tableList, setTableList] = useState([])
    // let [userList, setUsers] = useState([])
    // let loadTables = async () => {
    //     let {data} = await tableListFxn();
    //     setTableList(data);
    // }
    // let loadUsers = async () => {
    //     const {data} = await userListFxn();
    //     setUsers(data);
    // }

    useEffect(() => {
        getProducts()
        let currentDate = moment();
        let firstDayOfMonth = moment(currentDate).startOf('month');
        let lastDayOfMonth = moment(currentDate).endOf('month');
        props.form.setFieldsValue({
            fromD: firstDayOfMonth,
            toD: lastDayOfMonth,
        });
        // loadTables() //4-6-24
        // loadUsers() //4-6-24
    }, [])

    useEffect(() => {
        let fromDate = getFieldValue('fromD');
        let toDate = getFieldValue('toD');
        const fromDateObj = new Date(fromDate);
        const toDateObj = new Date(toDate);
        const timeDifference = Math.abs(toDateObj.getTime() - fromDateObj.getTime());
        const differenceInDays = Math.ceil(timeDifference / (1000 * 3600 * 24));

        if (differenceInDays > 31) {
            notification.warning({
                message: 'Difference Between From Date And To Date Cannot Exceeds 1 Month'
            });
            props.form.setFieldsValue({
                toD: ''
            })
        }
    }, [getFieldValue('fromD'), getFieldValue('toD')])


    const refreshTable = () => {
        tableRef.current.reload();
    };
    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Name",
            dataIndex: "_id",
            key: "_id",
            render: (text, record, index) => record.productName,

        },
        {
            title: "Quantity",
            dataIndex: "count",
            key: "count",
        },
        {
            title: "Net Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (text) => {
                return <>Rs. {text ? (text).toFixed(2) : 0}</>;
            },
        },
        {
            title: "Total Discount",
            dataIndex: "discount",
            key: "discount",
            render: (text) => {
                return <>Rs. {text ? (text).toFixed(2) : 0}</>;
            },
        },
        {
            title: "SGST",
            dataIndex: "sgstAmount",
            key: "sgstAmount",
            render: (text) => {
                return <>Rs. {text ? (text).toFixed(2) : 0}</>;
            },
        },
        {
            title: "CGST",
            dataIndex: "cgstAmount",
            key: "cgstAmount",
            render: (text) => {
                return <>Rs. {text ? (text).toFixed(2) : 0}</>;
            },
        },
        {
            title: "Total Tax",
            dataIndex: "totalTax",
            key: "totalTax",
            render: (_, record) => {
                const cgst = Number(record?.cgstAmount || 0);
                const sgst = Number(record?.sgstAmount || 0);
                const totalTax = (cgst + sgst).toFixed(2);
                return <>Rs. {totalTax}</>;
            },
        }
    ];

    let inputTypes = {
        fields: [
            {
                key: "productIds",
                label: "Select Products",
                placeholder: "Choose Products",
                type: "select",
                showStar: true,
                span: "col-md-6",
                options: products,
                multiple: true,
                showSearch: true,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => `${x.name}`,
                onChange: (x) => {
                    props.form.setFieldsValue({
                        productIds: x,
                    });
                },
            },
        ]

    };

    const getColumns = () => {
        let columnArr = [];
        _.each(columns, (item) => {
            if (!item.hide) {
                columnArr.push(item);
            }
        });
        return columnArr;
    };

    const handleDateTab = (key) => {
        setActiveTab(key);

        const today = new Date();
        let from, to;

        switch (key) {
            case "today":
                from = to = today;
                break;

            case "7days":
                from = new Date();
                from.setDate(today.getDate() - 7);
                to = today;
                break;

            case "1month":
                from = new Date();
                from.setMonth(today.getMonth() - 1);
                to = today;
                break;

            case "3months":
                from = new Date();
                from.setMonth(today.getMonth() - 3);
                to = today;
                break;

            case "custom":
                from = '';
                to = '';
                break;

            default:
                from = to = today;
        }

        setDates({fromDate: from, toDate: to});
    };


    return (
        <PageHeader title={"Products Reporting"}>
            <div className="row mb-3">
                <Form onSubmit={refreshTable}>
                    <div className="card">
                        <div className="card-body">
                            <div className="form-elements-wrapper">
                                <div className={"row"}>
                                    {/* Date Range Tabs */}
                                    <div className="col-md-12 mb-3">
                                        <div className="btn-group">
                                            {[
                                                {key: "today", label: "Today"},
                                                {key: "7days", label: "Last 7 Days"},
                                                {key: "1month", label: "Last Month"},
                                                {key: "3months", label: "Last 3 Months"},
                                                {key: "custom", label: "Custom"},
                                            ].map(tab => (
                                                <button
                                                    key={tab.key}
                                                    className={`btn btn-outline-primary ${activeTab === tab.key ? 'activeDuration' : ''}`}
                                                    onClick={() => handleDateTab(tab.key)}
                                                >
                                                    {tab.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Show DatePicker only when Custom is selected */}
                                    {activeTab == "custom" && (
                                        <>
                                            <div className="col-md-2">
                                                <InputBox title={'From Date'}>
                                                    <DatePicker
                                                        value={dates.fromDate}
                                                        showClear={true}
                                                        placeholder={'Choose from Date'}
                                                        onChange={(value) => setDates({...dates, fromDate: value})}
                                                    />
                                                </InputBox>
                                            </div>
                                            <div className="col-md-2">
                                                <InputBox title={'To Date'}>
                                                    <DatePicker
                                                        value={dates.toDate}
                                                        showClear={true}
                                                        placeholder={'Choose to Date'}
                                                        onChange={(value) => setDates({...dates, toDate: value})}
                                                    />
                                                </InputBox>
                                            </div>
                                        </>
                                    )}
                                    {inputTypes.fields.map((item, key) => {
                                        return (
                                            <div
                                                className={`${item.span ? item.span : "col-md-6"}`}
                                                key={key}
                                            >
                                                <GetEachFormFields {...props.form} item={item}/>
                                            </div>
                                        );
                                    })}
                                    <br/>
                                    <button className="btn btn-info col-md-1 ms-3 h-25 mt-4"
                                            onClick={refreshTable}>
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
            <div className="card">
                <div className="table-responsive">
                    <Table
                        apiRequest={apiRequest}
                        columns={getColumns()}
                        ref={tableRef}
                    />
                </div>
            </div>
        </PageHeader>
    );
}

export default Form.create()(GroupedProductsList);
